import TeamMember from "./TeamMember";
import { useMediaQuery } from 'react-responsive';
import './Team.css'
import {useEffect, useState} from "react";
import TeamDetail from "./TeamDetail";
import Separator from "../separator/Separator";

const teamMembers = [

    {
        id : 3,
        name: 'ANDRIAMAHENINTSOA Tafita Franckeinstein',
        position: ['-'],
        description: 'Développeur informatique et Porteur de projet Agri-Tech',
        image: 'team/Tafita.webp',
        presentation: 'ANDRIAMAHENINTSOA Tafita Franckeinstein est un entrepreneur innovant et un développeur \n' +
            'informatique passionné, doté d\'une solide expérience dans le domaine du développement logiciel et de \n' +
            'la gestion de projet. Son parcours académique et professionnel démontre son engagement envers \n' +
            'l\'innovation et son désir de contribuer au développement de solutions technologiques novatrices',
        role: 'En tant que Développeur informatique et Porteur de projet Agri-Tech Solution Madagascar, \n' +
            'ANDRIAMAHENINTSOA Tafita Franckeinstein est responsable de la conception, du développement et de \n' +
            'la mise en œuvre de solutions informatiques avancées pour soutenir l\'agriculture durable à Madagascar. \n' +
            'Il joue un rôle clé dans la définition de la vision stratégique du projet et dans la création d\'une \n' +
            'plateforme technologique robuste et évolutive.',
        contribution: 'ANDRIAMAHENINTSOA Tafita Franckeinstein a apporté une contribution significative au projet Agri-Tech \n' +
            'Solution Madagascar en tant qu\'initiateur et principal architecte de la plateforme technologique. Il a été \n' +
            'le moteur de l\'innovation en développant des solutions logicielles sur mesure pour répondre aux besoins \n' +
            'spécifiques de l\'agriculture malgache. Son expertise technique et sa vision entrepreneuriale ont été \n' +
            'essentielles pour transformer l\'idée en un projet concret et viable.',
        experiences : [
            {
                title: 'ONG Maison des Enfants',
                description: 'ANDRIAMAHENINTSOA Tafita Franckeinstein a accumulé une expérience diversifiée dans le domaine du \n' +
                    'développement informatique et de la gestion de projet. Ses précédentes collaborations avec l\'ONG \n' +
                    'Maison des Enfants témoignent de son engagement envers le développement social et de sa capacité à \n' +
                    'concevoir et à mettre en œuvre des systèmes d\'information efficaces. Son expertise en langages de \n' +
                    'programmation et en gestion de bases de données lui permet de créer des solutions logicielles \n' +
                    'innovantes et performantes.'
            },
            {
                title: 'Coach en leadership et en développement personnel',
                description: 'ANDRIAMAHENINTSOA Tafita Franckeinstein a guidé de nombreux individus dans le développement de leurs compétences en leadership et en développement personnel, renforçant ainsi leur capacité à mener des initiatives communautaires et professionnelles avec succès.'
            },
            {
                title: 'Animateur en développement social',
                description: 'En tant qu\'animateur en développement social, ANDRIAMAHENINTSOA Tafita Franckeinstein a travaillé directement avec les communautés rurales pour promouvoir des pratiques durables et améliorer les conditions de vie locales. Cette expérience lui a donné une perspective unique sur les défis et les opportunités du développement rural à Madagascar.'
            },
            {
                title: 'Résumé',
                description: 'En tant qu\'entrepreneur innovant, ANDRIAMAHENINTSOA Tafita Franckeinstein est passionné par la création de \n' +
                    'solutions technologiques qui ont un impact positif sur la société. Son dévouement envers le développement \n' +
                    'durable et son engagement envers l\'innovation font de lui un acteur clé dans la transformation de l\'agriculture à \n' +
                    'Madagascar.\n'
            }
        ]
    },
    {
        id : 20,
        name: 'ANDRIANALIMANANA Vahimisa Cynthia',
        position: ['-'],
        description: 'Enseignante et Chargée de Projet',
        image: 'team/Cynthia.webp',
        presentation: 'Vahimisa Cynthia est une enseignante dévouée et passionnée par l\'éducation et l\'innovation pédagogique. Forte de son expérience dans l\'enseignement des langues et sa capacité à communiquer efficacement, elle apporte une approche méthodique et structurée à chaque projet auquel elle participe. Cynthia est connue pour son engagement envers l\'amélioration des pratiques éducatives et son aptitude à travailler en équipe dans des environnements diversifiés.',
        role: 'En tant qu\'enseignante et chargée de projet, Vahimisa Cynthia joue un rôle crucial dans le développement des modules de formation pour l\'application Agri-Tech Solution. Elle est responsable de la conception et de la mise en œuvre des programmes éducatifs destinés aux agriculteurs, leur permettant ainsi de mieux comprendre et utiliser les nouvelles technologies agricoles pour optimiser leurs pratiques.',
        contribution: 'Cynthia apporte une contribution significative en assurant que les contenus pédagogiques soient accessibles, pertinents et adaptés aux besoins spécifiques des agriculteurs malgaches. Elle supervise la création des ressources de formation en ligne, organise des sessions de formation et fournit un soutien continu aux utilisateurs de l\'application. Son expertise en enseignement permet de garantir que les agriculteurs peuvent adopter efficacement les innovations technologiques proposées par Agri-Tech Solution.',
        experiences : [
            {
                title: 'Institutrice dans une ONG italienne',
                description: 'Cynthia a acquis une expérience précieuse en travaillant avec des enfants dans un contexte international, ce qui a renforcé ses compétences en communication interculturelle et en adaptation pédagogique.'
            },
            {
                title: 'Enseignante d\'anglais dans une école privée',
                description: 'En tant qu\'enseignante d\'anglais, elle a perfectionné ses compétences pédagogiques et sa capacité à transmettre des connaissances de manière claire et efficace. Cette expérience lui a permis de développer des méthodes d\'enseignement innovantes et de cultiver une compréhension profonde des besoins éducatifs des apprenants.'
            }
        ]
    },
    {
        id : 10,
        name: 'Hasina Juniolah Rivonandrasana',
        position: ['-', '-'],
        description: 'Développeur Python | IA et système embarqué',
        image: 'team/hasina.webp',
        presentation: 'Hasina Rivonandrasana est un développeur passionné par l\'intelligence artificielle, actuellement en Master 1 chez \n' +
            'ITUniversity. Il possède une solide base en Python et en Internet des Objets (IoT), qu\'il a renforcée par des cours \n' +
            'en ligne sur Kaggle. Il est particulièrement intéressé par l\'amélioration de l\'efficacité et de la précision des \n' +
            'systèmes d\'IA via l\'IoT',
        role: 'Au sein de notre projet, Hasina occupe le poste de Développeur Python | IA. Il est chargé de développer et de \n' +
            'maintenir des solutions d\'intelligence artificielle pour notre plateforme AgriTech, en se concentrant sur \n' +
            'l\'intégration de l\'IA et de l\'IoT pour optimiser les systèmes agricoles',
        contribution: 'Hasina apporte une expertise essentielle en développement Python et en IA. Il joue un rôle clé dans la mise en \n' +
            'œuvre des algorithmes d\'intelligence artificielle pour notre application Smart Farming. Ses compétences en \n' +
            'analyse de données et en prédiction de rendement, basées sur les conditions météorologiques, permettent \n' +
            'd\'optimiser les pratiques agricoles et de maximiser les rendements',
        experiences : [
            {
                title: 'Développement d’un Système de présence par caméra',
                description: 'Développement d\'un système capable d\'effectuer la présence des élèves par le biais des ' +
                    'caméras au sein du bâtiment de l\'ITUniversity. Cette solution a permis de raccourcir le procéssus de présence par un ' +
                    'simple click de bouton.'
            },
            {
                title: 'Développement d’un Système de détection de coupure',
                description: 'Détection automatique des coupures de courant au sein du bâtiment de l\'ITUniversity pour ' +
                    'améliorer le temps de réparation des pannes.'
            },
            {
                title: 'Développement d’un Système d\'Information pour le suivi de la consommation de l\'ITUniversity',
                description: 'Développement d\'un système d\'information pour surveiller et analyser la consommation énergétique à \n' +
                    'l\'ITUniversity'
            },
            {
                title: 'Prévention en cas d’insuffisance de production en énergie solaire',
                description: 'Analyse d\'image pour extraire des données des écrans des convertisseurs solaires.\n' +
                    'Prédiction du rendement en fonction des conditions météorologiques'
            },
        ]
    },
    {
        id : 4,
        name: 'Erick Philippe ANDRIAMIHAJARIVO',
        position: ['-'],
        description: 'Spécialiste en Ingénierie de Formation Agricole et Rurales',
        image: 'team/erick.webp',
        presentation: 'Erick Philippe ANDRIAMIHAJARIVO est un ingénieur agronome passionné par l\'agriculture durable et l\'innovation rurale. Avec \n' +
            'une solide expérience dans la formation des formateurs et l\'accompagnement des jeunes ruraux, il excelle dans la rédaction, \n' +
            'l\'analyse et la synthèse de données agricoles. Erick est également compétent en systèmes d\'information géographique (SIG) et \n' +
            'en conception audio-visuelle, apportant une approche multidisciplinaire à ses projets',
        role: 'Dans le cadre de notre projet, Erick occupe le rôle de consultant en ingénierie de formation agricole et rurale. Il est responsable \n' +
            'de concevoir et d\'implémenter des programmes de formation qui améliorent les compétences des agriculteurs et des \n' +
            'techniciens agricoles, tout en facilitant l\'adoption de pratiques agricoles durables.',
        contribution: 'Erick apporte une expertise précieuse en ingénierie de formation agricole, contribuant à la création de modules de formation \n' +
            'adaptés aux besoins locaux. Son expérience en agroécologie et en techniques de compostage est essentielle pour promouvoir \n' +
            'des pratiques agricoles respectueuses de l\'environnement. De plus, il joue un rôle clé dans l\'accompagnement des jeunes \n' +
            'agriculteurs et dans l\'amélioration des systèmes de gestion agricole au sein du projet.',
        experiences : [
            {
                title : 'Consultant-Formateur en Agroforesterie et agroécologie (Centre National de Formation des Techniciens Forestiers,\n' +
                    'Madagascar)\n',
                description : 'Formation des formateurs sur les techniques agroécologiques et de compostage'
            },
            {
                title : 'Consultant-Formateur en lombricompostage et élevage de Black Soldier Fly (Université Adventiste de Zurcher,\n' +
                    'Madagascar)',
                description : 'Formation sur les techniques de lombricompostage et l\'élevage de BSF.'
            },
            {
                title : 'Consultant (Centre National de Formation des Techniciens Forestiers)',
                description : 'Mise à jour du projet d’établissement et du plan de gestion de la station forestière d’Angavokely.'
            },
            {
                title : 'Consultant (Réseau FARMADA)',
                description : 'Mise à jour de la stratégie de gestion d’information et de communication.\n'
            },
            {
                title : 'Consultant - Formateur (Réseau FARMADA)\n',
                description : 'Renforcement de capacités des animateurs des centres de ressources des réseaux régionaux FAR.'
            },
            {
                title : 'Directeur Adjoint (Fekama – Fédération des collèges Agricole de Madagascar)',
                description : 'Responsable des activités d’insertion professionnelle des jeunes sortants des collèges agricoles, supervision des accompagnateurs, et élaboration \n' +
                    'de référentiels de formation.\n'
            },
        ]
    },
    {
        id : 1,
        name: 'Andrianay Miarintsoa Orlando',
        position: ['-', '-'],
        description: 'Développeur Web et Concepteur d\'Applications',
        image: 'team/Orlando.jpg',
        presentation: 'Andrianay Miarintsoa Orlando est un développeur passionné par l\'intelligence artificielle et la conception d\'applications. Dynamique et aimant le travail en équipe, il excelle dans le développement web, la création d\'applications et la gestion de bases de données.',
        role: 'Orlando occupe le poste de développeur web et concepteur d\'applications au sein de notre équipe. Il est responsable de la création et de la maintenance de nos solutions logicielles, en utilisant des technologies avancées pour assurer leur efficacité et leur performance.',
        contribution: 'Dans le cadre du projet Agri-Tech Solution, Orlando apporte une expertise essentielle en développement web et en gestion de bases de données. Il est chargé de la conception et de l\'implémentation de l\'application Smart Farming, en intégrant des fonctionnalités basées sur l\'intelligence artificielle pour optimiser la gestion agricole et fournir des recommandations personnalisées aux agriculteurs.',
        experiences : [
            {
                title: 'Transformation digitale, IT University',
                description: 'Actuellement impliqué dans la transformation digitale, apportant des solutions innovantes et optimisées pour divers projets.'
            },
            {
                title: 'Data Engineer chez HOAG TARGET',
                description: 'Administration de bases de données et développement en Python, NodeJS et Java. Il a mis en place le système de présence Happy Trace basé sur la reconnaissance faciale.'
            },
            {
                title: 'Création de Frameworks',
                description: 'StrawBerry : Paquet d’ORM pour l\'authentification et le CRUD. JVE : Extension Java pour la génération et la manipulation de tags HTML. ScaffoldReact : Outil pour la généralisation des tableaux de bord, CRUD, CSV, et PDF.'
            },
            {
                title: 'Participation au Salon de la Robotique',
                description: 'A obtenu la 2ème place pour le projet Smart House, qui incluait la gestion des personnels avec Java et l\'utilisation de cartes RFID pour la connexion via ESP32.'
            }
        ]
    },
    {
        id : 5,
        name: ' Eddie Meyer',
        position: ['-', '-', '-'],
        description: 'Développeur Web',
        image: 'team/njara.jpg',
        presentation: 'Eddie Meyer est un développeur web passionné par la technologie depuis son adolescence. À 13 ans, il a conçu \n' +
            'de manière autodidacte un logiciel calculatrice, marquant le début de sa carrière dans l\'innovation technologique. \n' +
            'Motivé par une quête constante de défis et de créativité, Eddie est prêt à apporter son expertise pour repousser \n' +
            'les limites de la technologie.',
        role: 'En tant que développeur web au sein de l\'équipe d\'AgriTech Solution, Eddie est responsable de la conception, du \n' +
            'développement et de la maintenance de la plateforme numérique. Son rôle crucial consiste à intégrer des \n' +
            'technologies avancées pour optimiser les outils agricoles proposés par la plateforme.',
        contribution: 'Eddie apporte une expertise technique indispensable à AgriTech Solution. Il se charge de développer une \n' +
            'application Smart Farming en utilisant l\'intelligence artificielle pour simplifier la gestion agricole. Grâce à ses \n' +
            'compétences, la plateforme offre des itinéraires techniques personnalisés pour chaque culture, améliore les \n' +
            'rendements agricoles, réduit les pertes et promeut une agriculture plus efficace.',
        experiences : [
            {
                title: 'Indépendant (Freelancer)',
                description: 'Réalisation de projets variés en freelance, incluant la gestion de piscines en France, des plateformes de commerce \n' +
                    'en ligne et des sites pour assurances seniors.'
            },
            {
                title: 'ENAC Group | Développeur Confirmé',
                description: 'Création de dashboards et de systèmes de monitoring pour diverses activités du groupe, ainsi que la refonte de cinq sites web en utilisant Symfony et Laravel.'
            },
            {
                title: 'StewTravel | Développeur Confirmé',
                description: 'Développement de sites de voyage et de planning avec Laravel et Symfony, et création de blogs avec WordPress.'
            },
            {
                title: 'Axian | Ingénieur d\'Étude et de Développement\n',
                description: 'Développement de solutions avec WordPress, Drupal et Angular. Mission de consultant chez Telma entre 2019 et \n' +
                    '2020'
            },
            {
                title: 'Résumé',
                description: 'Eddie Meyer, avec son expérience variée et ses compétences techniques pointues, est un élément clé de l\'équipe \n' +
                    'AgriTech Solution, prêt à transformer le secteur agricole grâce à des solutions technologiques avancées'
            },
        ]
    }
    // Ajoutez plus de membres si nécessaire
];

const Team = () => {
    const isDesktop = useMediaQuery({ minWidth: 992 });
    const [slideParam, setSlideParam] = useState(34);
    const [index, setIndex] = useState(0);
    const [display, setDisplay] = useState(3);
    const [userDetail, setUserDetail] = useState(false);
    const [userView, setUserView] = useState(null);
    useEffect(() => {
        // setTimeout(
        //     () =>
        //         setIndex((prevIndex) =>
        //             prevIndex === teamMembers.length - display ? 0 : prevIndex + 1
        //         ),
        //     delay
        // );

        return () => {};
    }, [index]);

    const changeIndex = (idx) => {
        if (idx <= teamMembers.length -display) {
            setIndex(idx)
        }
    }

    useEffect(() => {
        if (isDesktop) {
            setSlideParam(34);
            setDisplay(3);
        } else {
            setSlideParam(100);
            setDisplay(1);
        }
    }, [isDesktop]);

    return (
        <section id={"team"}>
            <div className={"container"}>
                <div className={"team-container"}>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <h2  className={"title animate"}>Notre équipe</h2>
                        </div>
                        <div className={"slide-container animate"}>
                            <div className={"slideshowSlider"}
                                 style={{ transform: `translate(${-(index*slideParam)}%, 0)` }}
                            >

                                {teamMembers.map((member, index) => (
                                    <TeamMember
                                        key={index}
                                        name={member.name}
                                        position={member.position}
                                        description={member.description}
                                        image={member.image}
                                        click={() => {
                                            setUserDetail(true);
                                            setUserView(member)
                                        }}
                                    />
                                ))}
                            </div>
                        </div>

                        {userDetail?
                            <TeamDetail user={userView} close={() => {
                                setUserDetail(false)
                            }
                            }></TeamDetail>: <></>
                        }

                        <div className="slideshowDots">
                            {teamMembers.map((_, idx) => (
                                <>
                                    {
                                        (isDesktop && idx <= teamMembers.length - display) || !isDesktop ?
                                            <div key={idx}
                                                 className={`slideshowDot${index === idx ? " active" : ""}`}
                                                 onClick={() => {
                                                     changeIndex(idx);
                                                 }}
                                            ></div>
                                            :<></>
                                    }
                                </>
                            ))}
                        </div>

                    </div>
                    <Separator first={"legume/drone.webp"} second={"legume/rice.webp"} third={"legume/robot.webp"}></Separator>

                </div>
            </div>
        </section>
    )
}

export default Team;